import Button from './form/button';
import * as searchHelper from "./helpers/search-helper";
import * as activityLogger from "./helpers/activity-logger";

// Fade header out on scroll
document.addEventListener('scroll', () =>{
    const topPos = document.documentElement.scrollTop;
    const mobileHeader = document.querySelector('.mobile-header');

    if (mobileHeader !== null){
        if (topPos > 80){
            mobileHeader.classList.add('scrolled');
        } else {
            mobileHeader.classList.remove('scrolled');
        }
    }
});

$('.currency-btn.desktop').on('click', function () {
    $(this).toggleClass('active');
    $(this).next('.currency-list').toggleClass('active');
});

$("body").click(function(e) {
    if (!$(e.target).closest('.currency-btn.desktop').length) {
        if ($('.currency-list.desktop').hasClass('active')) {
            $('.currency-list.desktop').removeClass('active');
        }
    }
});

$('.currency-list li').on('click', function (e) {
    e.preventDefault();
    axios({
        method: 'POST',
        url: $(this).children('span').data('url'),
    })
    .then(function (response) {
        if (response.data.success) {
            window.location.reload();
        }
    })
    .catch(function (error) {
        console.log(error);
    });
});

const accountBtnDesktop = document.querySelector('.account-identity-btn.desktop');

if (accountBtnDesktop !== null){
    accountBtnDesktop.addEventListener('click', accountList);
}

function accountList(e){
    e.target.classList.toggle('active');
}

// Account link : submenu
const accountLinkDesktop = document.querySelectorAll('.account-link');
if (accountLinkDesktop !== null){
    for (let i = 0; i < accountLinkDesktop.length; i++) {
        accountLinkDesktop[i].addEventListener('click', (e) => {
            e.stopPropagation(); // stop dropdown menu from closing on click of menu link
            accountLinkDesktop[i].nextElementSibling.classList.toggle('active');
        });
    }
}

$('#accountList li, #accountListMobile li').on('click', function () {
    let accountLinkBtn = new Button(this);
    accountLinkBtn.turnLoadingOn();

    axios({
        method: 'POST',
        url: '/auth/viewaslinked',
        data: { 'acc': $(this).data('acc') }
    })
    .then(function (response) {
        if (response.data.success) {
            window.location.reload();
            accountLinkBtn.turnLoadingOff();
        } else {
            //alert(response.data.msg);
        }
    })
    .catch(function (error) {
        console.log(error);
    });
});

// Contact search
$(function () {
    function initContactSearch(elementId) {
        $(`#${elementId}`).select2({
            selectionCssClass: 'slate-light-border',
            language: {
                inputTooShort: function () {
                    return 'Enter search text';
                }
            },
            ajax: {
                url: '/contact/search/',
                delay: 250,
                dataType: 'json',
                data: function (params) {
                    return {
                        query: params.term,
                    };
                },
                processResults: function (data) {
                    var options = [];

                    $.each(data.suggestions, function (index, suggestion) {
                        options.push({
                            id: suggestion.masterAccountNum + '|' + suggestion.email + '|' + suggestion.accountName,
                            text: suggestion.accountNum + ' | ' + suggestion.masterAccountNum + ' | ' + suggestion.accountName,
                            email: suggestion.email,
                            masterAccount: suggestion.masterAccountNum,
                            firstName: suggestion.firstName,
                            lastName: suggestion.lastName,
                        });
                    });

                    return {
                        results: options
                    };
                },
                cache: true
            },
            placeholder: "Search accounts...",
            minimumInputLength: 2,
            width: 'resolve',
            dropdownAutoWidth: true,
            allowClear: true,
            multiple: true,
        })
            .on("select2:select", function (e) {
                $("body").addClass("wait");
                const data = e.params.data;
                axios({
                    method: 'POST',
                    url: '/auth/viewas',
                    data: {
                        'acc': data.masterAccount,
                        'email': data.email,
                        'firstName': data.firstName,
                        'lastName': data.lastName
                    }
                })
                    .then(function (response) {
                        if (response.data.success) {
                            window.location.reload();
                        } else {
                            $("body").removeClass("wait");
                            alert(response.data.msg);
                        }
                    })
                    .catch(function (error) {
                        $("body").removeClass("wait");
                        console.log(error);
                    });
            });
    }
    initContactSearch("contact_accounts");
    initContactSearch("contact_accounts_mobile");
});

$('#currencyList a').on('click', function () {
    $("body").css("cursor", "progress");
});

// Manipulation based on LIVETRADE body class
if (document.body.classList.contains('livetrade-layout')) {

    // Manipulate search submit for LiveTrade only
    $(document).on('submit', '.livetrade-plus .search-form.search.livetrade', function(e) {
        let searchValue = $(this).find('input[name="search"]').val();
        activityLogger.logSearchActivity('Header: LT Plus Marketplace', searchValue, 'No data available for numResults. Left empty from codebase intentionally');
        history.pushState(null, null, '/livetrade/livetrade-plus/' + encodeURIComponent(searchValue));
        e.preventDefault();
    });

    $(document).on('submit', '.tight-spreads .search-form.search.livetrade', function(e) {
        let searchValue = $(this).find('input[name="search"]').val();
        activityLogger.logSearchActivity('Header: Tight Spreads', searchValue, 'No data available for numResults. Left empty from codebase intentionally');
        history.pushState(null, null, '/livetrade/tight-spreads/' + encodeURIComponent(searchValue));
        e.preventDefault();
    });

    $(document).on('submit', '#quick_search_mobile, #headerSearchForm, .marketplace .search-form.search.livetrade, .marketplace-region .search-form.search.livetrade', function(e) {
        e.preventDefault();
        $("#marketplace").addClass("loading-indicator");
        let searchValue = $(this).find('input[name="search"]').val();
        activityLogger.logSearchActivity('Header: Marketplace', searchValue, 'No data available for numResults. Left empty from codebase intentionally');
        window.location.href = "/livetrade/marketplace/" + encodeURIComponent(searchValue);
    });
} else{
    $(document).on("submit", "form[name='header-search-form'], #quick_search_mobile", function(e) {
        e.preventDefault();

        const $searchInputEl = $("input[name='search']", $(this));
        const searchString = $searchInputEl.val();
        $searchInputEl.val(searchHelper.mapTerms(searchString));
        this.submit();
    });
}